"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NArray = void 0;
var moment_1 = __importDefault(require("moment"));
moment_1.default.updateLocale('en', {
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: 'a few secs',
        ss: '%d secs',
        m: "a min",
        mm: "%d mins",
        h: "an hour",
        hh: "%d hrs",
        d: "a day",
        dd: "%d days",
        M: "a mth",
        MM: "%d mths",
        y: "a yr",
        yy: "%d yrs"
    }
});
function NArray(length) {
    var arr = [];
    for (var i = 0; i < length; i++) {
        arr.push(i);
    }
    return arr;
}
exports.NArray = NArray;
if (!Array.prototype.sum)
    // eslint-disable-next-line no-extend-native
    Array.prototype.sum = function () {
        return this.reduce(function (a, b) { return a + b; }, 0);
    };
if (!Array.prototype.last) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.last = function () {
        if (!this.length) {
            return undefined;
        }
        return this[this.length - 1];
    };
}
if (!Array.prototype.sortDir) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.sortDir = function (on, dir) {
        if (dir === undefined) {
            return this;
        }
        function diff(aVal, bVal) {
            if ((aVal === null || aVal === undefined) && (bVal === null || bVal === undefined)) {
                return 0;
            }
            if (aVal === null || aVal === undefined) {
                return 1;
            }
            if (bVal === null || bVal === undefined) {
                return -1;
            }
            if (typeof aVal == 'string' && typeof bVal == 'string') {
                return (dir === 'asc' ? 1 : -1) * (aVal.localeCompare(bVal));
            }
            if (typeof aVal == 'number' && typeof bVal == 'number') {
                return (dir === 'asc' ? 1 : -1) * (aVal - bVal);
            }
            return 0;
        }
        return this.slice().sort(function (a, b) {
            var aVal = on(a);
            var bVal = on(b);
            if (!Array.isArray(aVal) && !Array.isArray(bVal)) {
                return diff(aVal, bVal);
            }
            if (Array.isArray(aVal) && Array.isArray(bVal)) {
                var diffVal = 0;
                for (var i = 0; i < aVal.length; i++) {
                    diffVal = diff(aVal[i], bVal[i]);
                    if (diffVal !== 0)
                        return diffVal;
                }
            }
            return 0;
        });
    };
}
if (!Array.prototype.groupBy) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.groupBy = function (on) {
        var dataMap = {};
        this.forEach(function (item) {
            var key = on(item);
            if (!dataMap[key])
                dataMap[key] = [];
            dataMap[key].push(item);
        });
        return Object.keys(dataMap).map(function (key) {
            return {
                group: key,
                items: dataMap[key]
            };
        });
    };
}
if (!Array.prototype.cumulative) {
    // eslint-disable-next-line no-extend-native
    Array.prototype.cumulative = function (addUp) {
        var sum = 0;
        this.forEach(function (item) {
            sum = addUp(item, sum);
        });
        return sum;
    };
}
if (!Number.prototype.currency) {
    // eslint-disable-next-line no-extend-native
    Number.prototype.currency = function (digits, short) {
        if (digits === void 0) { digits = 0; }
        if (short === void 0) { short = false; }
        if (short) {
            if (this >= 10000000)
                return (this.valueOf() / 10000000).currency(digits, true) + "Cr";
            else if (this >= 100000)
                return (this.valueOf() / 100000).currency(digits, true) + "L";
            else if (this >= 1000)
                return (this.valueOf() / 1000).currency(digits, true) + "K";
            else
                return this.currency(digits);
        }
        return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: digits, maximumFractionDigits: digits, }).format(this.valueOf());
    };
}
if (!Number.prototype.percentage) {
    // eslint-disable-next-line no-extend-native
    Number.prototype.percentage = function (digits) {
        if (digits === void 0) { digits = 1; }
        return this.valueOf().toFixed(digits) + "%";
    };
}
